<template>
  <div class="app-container">
    <div class="filter-container">
      <!-- <el-button class="filter-item" type="primary" @click="handleCreate"
        >新增</el-button
      > -->
      <el-input
        v-model="listQuery.name"
        placeholder="请输入学生姓名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="冻结" :value="0" />
      </el-select>
      <el-date-picker
        class="filter-item"
        v-model="entrance_at"
        type="month"
        value-format="yyyy-MM"
        placeholder="选择入学时间"
      >
      </el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        type="success"
        @click="handleAdd"
        :loading="btnLoading"
      >
        添加选中学生
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="学生姓名" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.name }} </template>
      </el-table-column>
      <el-table-column label="学号" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.account }} </template>
      </el-table-column>
      <el-table-column label="院系" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.college.name }} </template>
      </el-table-column>
      <!-- <el-table-column label="专业" min-width="110" align="center">
        <template slot-scope="scope">{{scope.row.name}}  </template>
      </el-table-column> -->
      <el-table-column label="入学时间" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.entrance_at }} </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_normal">正常</el-tag>
          <el-tag type="danger" v-else>冻结</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleAdd(scope.row)"
            :loading="btnLoading"
          >
            添加
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        name: "",
        not_grade_id: "",
        is_normal: "",
      },
      entrance_at: "",
      textMap: { update: "修改", create: "新增" },
      dialogFormVisible: false,
      dialogStatus: "",
      btnLoading: false,
      colleges: [],
      form: {
        id: "",
        class_id: "",
        study_year_num: "",
        student_ids: [],
      },
      rules: {
        entrance_at: [
          { required: true, message: "入学时间不能为空", trigger: "change" },
        ],
        college_id: [
          { required: true, message: "院系不能为空", trigger: "change" },
        ],
        name: [
          { required: true, message: "学生姓名不能为空", trigger: "change" },
        ],
        account: [
          {
            required: true,
            message: "学生学号不能为空",
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: "学生电话不能为空", trigger: "change" },
        ],
      },
      college_ids: [], //院系
      multipleSelection: [], //选中列表
    };
  },
  created() {
    this.form.class_id = this.$route.query.id;
    this.form.study_year_num = this.$route.query.study_year_num;
    this.listQuery.not_class_id = this.$route.query.id;
    this.listQuery.school_id = this.$route.query.school_id;
    // this.listQuery.colleage_id = this.$route.query.college_id;
    this.getCollegeList();
    this.getList();
  },
  watch: {
    entrance_at(newVlue, old) {
      if (!newVlue) {
        this.listQuery.year = "";
        this.listQuery.month = "";
      }
    },
  },
  methods: {
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    handleAdd(row) {
      this.form.student_ids = [];
      this.form.school_id = this.listQuery.school_id;
      if (row.id) {
        console.log(row);
        this.form.student_ids.push(row.id);
      } else if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((item) => {
          this.form.student_ids.push(item.id);
        });
      } else {
        return;
      }
      console.log(111);
      this.btnLoading = true;
      request({
        url: "/api/backend/school/classAddStudent",
        method: "post",
        data: this.form,
      })
        .then((response) => {
          this.btnLoading = false;
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.getList();
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
    handleSchedule() {
      this.$router.push(`/school/check_curriculum`);
    },
    getCollegeList() {
      request({
        url: "/api/backend/school/collegeList",
        method: "get",
        params: {
          limit: 999999999999999,
        },
      }).then((response) => {
        this.colleges = response.data.data;
      });
    },
    getList() {
      this.listLoading = true;
      // this.listQuery.entrance_at=''
      request({
        url: "/api/backend/student/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      if (this.entrance_at) {
        this.listQuery.year = this.entrance_at.split("-")[0];
        this.listQuery.month = this.entrance_at.split("-")[1];
      }
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
      };
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/student/store",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该院系, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/student/changeNormal",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //上下架
    initPassword(val, text) {
      this.$confirm("此操作将" + text + "该院系, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/student/initPassword",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
